
import { Injectable, EventEmitter } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import {throwError as observableThrowError,  Observable ,  Subject, throwError } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { DataLayer } from './data-layer';
import { dataLayerDetails } from './data-layer-definitions';
import { ConfigService } from './config.service';
import { AppConfigService } from './app-config.service';

// declare all javascript variables/functions defined elsewhere

@Injectable()
export class DataLayerService {
	http: HttpClient;
	novaScores: any[];
	alarmTriggers: any[];

	addnlDataLayersDefinitions: any[];
	currentAddnlDataLayer;

	rainfallIntervalOptions: any[] = [
		{ label: "15-Minute Rainfall", value: "15-Minute Rainfall" },
		{ label: "30-Minute Rainfall", value: "30-Minute Rainfall"},
		{ label: "1-Hour Rainfall", value: "1-Hour Rainfall"},
		{ label: "3-Hour Rainfall", value: "3-Hour Rainfall"},
		{ label: "6-Hour Rainfall", value: "6-Hour Rainfall"},
		{ label: "12-Hour Rainfall", value: "12-Hour Rainfall"},
		{ label: "24-Hour Rainfall", value: "24-Hour Rainfall"},
		{ label: "3-Day Rainfall", value: "3-Day Rainfall"},
		{ label: "7-Day Rainfall", value: "7-Day Rainfall"},
		/*
		{ label: "14-Day Rainfall", value: "14-Day Rainfall"},
		{ label: "21-Day Rainfall", value: "21-Day Rainfall"},
		*/
		{ label: "30-Day Rainfall", value: "30-Day Rainfall"}
	]
	rainfallInterval = "24-Hour Rainfall";


	// legendList controls the contents of the map legend
	// legendListSource is a subject that gets values added using 'next'
	// legendList$ is the observable other components can subscribe to
	private legendListSource = new Subject<{}>();
	legendList$;

	// filterEvent controls the emitter that forces the refiltering of stations on the map based on search provided by user
	// filterEventSource is a subject that gets values added using 'next'
	// legendList$ is the observable other components can subscribe to
	private filterEventSource = new Subject<{}>();
	filterEvent$;

	// tooltips contain data for different periods of record
	// the following array defines those tables
	tooltipTablePORPrecip = ['15Minute', '30Minute', '1Hour', '3Hour', '6Hour', '12Hour', 
		'1Day', '3Day', '7Day', '30Day'];
	tooltipTablePOROther = ['15Minute', '1Hour', '3Hour', '1Day', '7Day'];

	flowNRCount: number;
	flowNSCount: number;
	flowNS1Count: number;
	flowNS2Count: number;
	flowNS3Count: number;
	flowNS4Count: number;
	flowNS5Count: number;
	stageNRCount: number;
	stageNSCount: number;
	stageNS1Count: number;
	stageNS2Count: number;
	stageNS3Count: number;
	stageNS4Count: number;
	stageNS5Count: number;
	precipNRCount: number;
	precipNSCount: number;
	precipNS1Count: number;
	precipNS2Count: number;
	precipNS3Count: number;
	precipNS4Count: number;
	precipNS5Count: number;
	fitNS14Count: number;
	fitNS15Count: number;
	fitNS16Count: number;
	fitNS17Count: number;
	fitNS18Count: number;

	constructor (http: HttpClient, 
		private appConfigService: AppConfigService,
		private configService: ConfigService ) {
			this.http = http;
			this.legendList$ = this.legendListSource.asObservable();
			this.filterEvent$ = this.filterEventSource.asObservable();

			// create all the valueObservers for data display layers.
			this.createValueObserver('allStations');
			this.createValueObserver('streamFlowStations');
			this.createValueObserver('waterLevelStations');
			this.createValueObserver('precipStations');
			this.createValueObserver('addnlData');
			this.createValueObserver('fitAssetsGeoJSON');
			// set up dropdown values for the additional data layers
			this.processAdditionalDataDisplayLayers();
	}
 
	createValueObserver ( dataType ) {
		// console.log('Creating value observable for ' + dataType);
		const dataLayer = this.getDataLayerDetails ( dataType );
		dataLayer.valueObserver = dataLayer.valueObservable.asObservable();
		/*
		if ( dataLayer.valueObservable == null ) {
			dataLayer.valueObservable = new Subject<any>();
			console.log('Creating subject for ' + dataType + ' data layer.');
		}
		*/
	}

	// getDataLayers returns all data layers
	getDataLayers() {
		// console.log(dataLayerDetails);
		return Promise.resolve(dataLayerDetails);
	}

	// remove any dynamic overlay layers
	clearDynamicOverlayLayers() {
		console.log(dataLayerDetails);
		for ( let i = dataLayerDetails.length - 1; i >= 0; i--) {
			if ( dataLayerDetails[i].dataType == 'dynamicOverlayLayer' ) {
				dataLayerDetails.splice(i,1);
			}
		}
	}

	// Retrieve the definitions for the addition
	// layers dropdown; 
	processAdditionalDataDisplayLayers() {
		this.addnlDataLayersDefinitions = this.appConfigService.getAdditionalDataDisplayLayers();
		console.log(this.addnlDataLayersDefinitions);
		if ( this.addnlDataLayersDefinitions.length > 0 ) {
			this.currentAddnlDataLayer = 
			this.addnlDataLayersDefinitions[0];
		}
	}

	// assign the data to the
	// dataLayerDetails object 'dataType': 'addnlData'

	getAdditionalDataDisplayLayersDefinitions() {
		return this.addnlDataLayersDefinitions;
	}
	
	getRainfallIntervalOptions() {
		return this.rainfallIntervalOptions;
	}

	// getDataLayerDetails returns only a single requested data type which includes all
	// data types defined in data-layer-definitions and matches the field "dataType", i.e.
	// "allStations"
	// "streamFlowStations"
	// "fitAssets"
	// "waterLevelStations"
	// "precipStations"
	// "cameraStations"
	// getDataLayerDetails(dataType: string) {
		// return Promise.resolve(dataLayerDetails).then (
			// dlayers => dlayers.filter(dl => dl.dataType === dataType)[0]
		// );
	// }
	getDataLayerDetails(dataType: string) {
		return (dataLayerDetails).filter(dl => dl.dataType === dataType)[0];
	}

	// parses the stationSummaries.json file and stores the results in the "allStations" layer
	parseAllStations () {

		const self = this;
		return new Promise(function(resolve, reject) {

		const requestAllStations = new XMLHttpRequest();
		requestAllStations.onload = function ( ) {
			if ( requestAllStations.readyState === requestAllStations.DONE ) {
				if ( requestAllStations.status === 200 ) {

					// first, get json file content
					const allStations = JSON.parse(requestAllStations.responseText);

					// console.log(allStations);

					const dataLayer = self.getDataLayerDetails ( 'allStations' );
					dataLayer.value = allStations;
					// console.log ( dataLayer );
					console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all stations successfully completed.');
					resolve(allStations);
				} else {	// request status wasn't 200
					console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all stations was UNSUCCESSFUL.');
					reject(Error(requestAllStations.statusText));
				}
			}
		};

		// console.log(self.configService.userName);
		const uri = self.configService.createURI ( { 'filename': 'stationSummaries.json' });
		// console.log(uri);

		requestAllStations.open('get', uri, true );
		console.log('[' + new Date().toLocaleTimeString() + '] Attempting to read ' + uri + ' for all stations.');
		requestAllStations.send();
		});
	}

	parseAllStationsObservable () {

		const self = this;

		const requestAllStations = new XMLHttpRequest();
		requestAllStations.onload = function ( ) {
			if ( requestAllStations.readyState === requestAllStations.DONE ) {
				if ( requestAllStations.status === 200 ) {

					// first, get json file content
					const allStations = JSON.parse(requestAllStations.responseText);

					// console.log(allStations);

					const dataLayer = self.getDataLayerDetails ( 'allStations' );
					dataLayer.value = allStations;
					dataLayer.valueObservable.next( allStations );
					// console.log ( dataLayer );
					console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri +
						' for all stations successfully completed AND ADDED TO OBSERVABLE.');
					// console.log(allStations);
				} else {	// request status wasn't 200
					console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all stations was UNSUCCESSFUL.');
					throwError('hello');
				}
			}
		};
		requestAllStations.ontimeout = function() {
			console.log('Timeout occurred while setting up parsing all stations observable.')
					throwError('hello');
		}

		// console.log(self.configService.userName);
		const uri = self.configService.createURI ( { 'filename': 'stationSummaries.json' });
		requestAllStations.open('get', uri, true );
		console.log('[' + new Date().toLocaleTimeString() + '] Attempting to read ' + uri + ' for all stations.');
		requestAllStations.send();
	}

	// Using data web services, get stationSummaries in geojson format
	// A promise is returned that ultimately results in the geojson content or the status Text for an error
	retrieveAllStationsGeojson () {
		const self = this;

		return new Promise(function(resolve, reject) {

			const request = new XMLHttpRequest();
			request.onload = function ( ) {
				if ( request.readyState === request.DONE ) {
					if ( request.status === 200 ) {
						// first, get geojson file content
						const tmpFlowStations = JSON.parse(request.responseText);
						console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri +
								' for all stations in geojson format was successfully completed.');
						resolve(tmpFlowStations);
					} else {	// request status wasn't 200
						console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all stations in geojson format was UNSUCCESSFUL.');
						reject(Error(request.statusText));
					}
				}
			};

			const uri = self.configService.createURI ( { 'filename': 'stationSummaries.geojson' });
			request.open('get', uri, true );
			console.log('[' + new Date().toLocaleTimeString() + '] Attempting to read ' + uri + ' for all stations in geojson format.');
			request.send();
		});
	}


	// parses the floodImpactSummaries.json file and stores the results in the "fitAssets" layer
	parseAllFloodImpactStations () {

		const self = this;

		const requestAllStations = new XMLHttpRequest();
		requestAllStations.onload = function ( ) {
			if ( requestAllStations.readyState === requestAllStations.DONE && requestAllStations.status === 200 ) {

				// first, get json file content
				const allFITStations = JSON.parse(requestAllStations.responseText);
				// console.log(allFITStations);

				const dataLayer = self.getDataLayerDetails ( 'fitAssets' );
				dataLayer.value = allFITStations;
				console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all flood impact assets was completed successfully.');
				// console.log ( dataLayer );
			}else {
				console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all flood impact assets was UNSUCCESSFUL.');
			}
		};
		const uri = this.configService.createURI ( { 'filename': 'floodImpactSummaries.json' });
		requestAllStations.open('get', uri, true );
		console.log('[' + new Date().toLocaleTimeString() + '] Attempting to read ' + uri + ' for all flood impact assets.');
		requestAllStations.send();

	}

	// Given a groupScoreOrder, return the description.
	//
	convertGroupNovaScoreToDescription ( novaScores: any[], groupScoreOrder ) {  // may need to add scoreGroup
		const nsArray = novaScores.filter(function(stat) {
									return stat.groupScoreOrder === groupScoreOrder; });

		if ( nsArray.length > 0 ) {
			return nsArray[0].description;
		} else { return ''; }
	}

	// Convert a novascore from novascore to groupScoreOrder.
	//
	convertNovaScore ( novaScores: any[], novascore ) {  // may need to add scoreGroup
		const nsArray = novaScores.filter(function(stat) {
									return stat.id === novascore; });

		if ( nsArray.length > 0 ) {
			return nsArray[0].groupScoreOrder;
		} else { 
			// console.log('Unable to convert ' + novascore + ' to a novascore group order.', novaScores);
			return 1; 
		}
	}
	// set the novaScores variable to the novaScores array in the summaries file
	// pass in file json object representing the summaries file.
	parseAndSetNovaScores (stationSummaries) {
		let novaScores;
		for ( let i = 0; i < stationSummaries.properties.length; i++ ) {
			if ( stationSummaries.properties[i].hasOwnProperty ('novaScores')) {
				this.novaScores = stationSummaries.properties[i].novaScores;
				novaScores = stationSummaries.properties[i].novaScores;
				break;
			}
		}
		// console.log(this.novaScores);
		return novaScores;
	}

	// set the alarm triggers variable to the alarm triggers array in the summaries file
	// pass in file json object representing the summaries file.
	parseAndSetAlarmTriggers (stationSummaries) {
		let alarmTriggers;
		for ( let i = 0; i < stationSummaries.properties.length; i++ ) {
			if ( stationSummaries.properties[i].hasOwnProperty ('alarmTriggers')) {
				this.alarmTriggers = stationSummaries.properties[i].alarmTriggers;
				alarmTriggers = stationSummaries.properties[i].alarmTriggers;
				break;
			}
		}
		// console.log(this.alarmTriggers);
		return alarmTriggers;
	}

	// Create a message to indicate if this station is in an alarm status.
	createAlarmMessage ( alarms, alarmTriggers ) {
		let alarmMessage = '';
		try {
			if ( alarms.length > 0 ) {
				for ( let i = 0; i < alarms.length; i++ ) {
					// get the alarm name
					if ( alarms[i].alarmState === 'Active' ) {

					let alarmName = '';
					let novaScoreClass = '';
					let novaScore = 1;
					const alarmsArray = alarmTriggers.filter(function(stat) {
									return stat.id === alarms[i].triggerId; });
					if ( alarmsArray.length > 0 ) {
						alarmName = alarmsArray[0].name;
						novaScore= alarmsArray[0].novaScore;
						novaScoreClass = 'class = "novascore' + alarmsArray[0].novaScore + '"';
					}
					// create the alarm hover message
					const alarmDateTime = 
						this.dateToISOButLocal(alarms[i].alarmDateTime);
					alarmMessage += 
						'<tr><td>' + alarmDateTime +
						'</td><td>' + alarmName +
						'</td><td ' + novaScoreClass + '>' + novaScore +
						'</td><td>' + alarms[i].triggerValue + ' ' + alarms[i].triggerValueUnits +
						'</td><td>' + alarms[i].triggerMessage + '</td></tr>';
					}
				}
				if ( alarmMessage.length > 0 ) {
					const alarmHeader = '<tr>' +
						'<th>Date/time</th>' +
						'<th>Alarm name</th>' +
						'<th>NovaScore</th>' +
						'<th>Trigger value</th>' +
						'<th>Message</th></tr>';
					alarmMessage = '<br>Active alarms:<table class="tt">'  + 
						alarmHeader + alarmMessage + '</table>';
				}
			}
		} catch (err) {
			console.log('Error processing alarm.');
		}
		return alarmMessage;
	}

	// Search entire layer for features that are located at the given latitude/longitude
	// Return the html string used for the popup including a button to click to view the dashboard.
	createPopupContent ( features, latitude, longitude ) {
		// console.log('In create PopupContent');
		let popupString = '';

		features.forEach(function(feature, index) {
			if ( feature.properties.stationSummary.latitude === latitude && feature.properties.stationSummary.longitude === longitude ) {
				popupString += 	"<p style='font-size:20px'>" +
							"Station name: " + feature.properties.stationSummary.name + 
							"<br>Station id: " + feature.properties.stationSummary.numId +
							"<input type='image' class='viewDescription' src='assets/images/viewDescriptionEyeLeft.png' onclick='globalMapComponent.showDetail(" +
							feature.properties.stationSummary.numId + ")' title='Click to view tooltip information in a scrollable dialog.'>" +
							"</p> <button class=\"popupButton\" onclick='globalMapComponent.gotoDetail(" +
							feature.properties.stationSummary.numId +
							")'>Go to Station Dashboard</button>";
				}
		});
		return popupString;
	}

	getDurationString ( duration ) {
		switch ( duration ) { 
			case '15Minute': return '15 Minutes'; break;
			case '30Minute': return '30 Minutes'; break;
			case '1Hour': return '1 Hour'; break;
			case '3Hour': return '3 Hours'; break;
			case '6Hour': return '6 Hours'; break;
			case '12Hour': return '12 Hours'; break;
			case '1Day': return '1 Day'; break;
			case '3Day': return '3 Days'; break;
			case '7Day': return '7 Days'; break;
			case '30Day': return '30 Days'; break;
			default: return 'Undefined';
		}

	}

	// stats are the statistic filtered by the current data type
	// return the last statistic that has a value in order to understand
	// dates for the tooltip
	getLastReportStatistic ( stats, statisticType ) {
		let lastReport = null;

		if ( stats == null || stats.length == 0 ) {
			return lastReport;
		}
		const tStat = stats.filter(function(stat) {
			return stat.statisticType === statisticType;
		});

		for ( let i = 0; i < tStat.length; i++ ) {
			if ( tStat[i].statisticDateTime != null ) {
				lastReport = tStat[i];
				// end loop
				i = tStat.length;
			}
		}
		return lastReport;
	}

	// Create the content when the user hovers over a station.
	//
	// This function creates only the table for the tooltip
	createTooltipTable ( dataTypeStatistics, statisticType, columns ) {
		let statisticsSummary = '<table class="tt">';
		
		statisticsSummary += this.createTooltipTableHeader (columns);

		for ( let i = 0; i < statisticType.length; i++ ) {
			const tmpStatistics = dataTypeStatistics.filter(function(stat) {
				return stat.statisticType === statisticType[i];
			});
			statisticsSummary += this.createTooltipTableRow ( 
				tmpStatistics, statisticType[i], columns );
		}
		statisticsSummary += '</table>';
		return statisticsSummary;
	}

	createTooltipTableHeader ( columns ) {
		let statisticsHeader = '<tr>';
		statisticsHeader += '<th>Statistic</th>';
		for ( let i = 0; i < columns.length; i++ ) {
			const duration = columns[i];
			statisticsHeader += '<th>' + this.getDurationString(duration) + '</th>';
		}
		statisticsHeader += '</tr>';
		return statisticsHeader;
	}

	createTooltipTableRow ( dataTypeStatistics, statisticType, columns ) {
		let statisticsStats = '<tr>';
		let first = true;

		// create the statistics summary which includes all durations
		for ( let i = 0; i < columns.length; i++ ) {
			const duration = columns[i];
			const s = dataTypeStatistics.filter(function(stat) {
				return stat.duration === duration;
			});
			if ( first == true ) {  // set units in table
				const units = dataTypeStatistics.length > 0 ? 
					dataTypeStatistics[0].statisticUnits: 'in';
				const dataType = dataTypeStatistics.length > 0 ?
					' ' + dataTypeStatistics[0].dataType + ' ' : '';
				statisticsStats += '<td>' + dataType + statisticType + 
					' (' + units + ')</td>';
				first = false;
			}

			if ( s.length > 0 && s[0].statisticValue != null ) {
				statisticsStats += '<td>' + s[0].statisticValue.toFixed(2) + '</td>';

				// special circumstances for statistic type of "Last"
				// only 1 value shall be displayed
				if ( statisticType === 'Last') {
					while ( ++i < columns.length ) {
						statisticsStats += '<td class="nullCell">' + '</td>';
					}
				}
			}
			else {
				statisticsStats += '<td class="nullCell">' + '</td>';
			}
		}
		statisticsStats += '</tr>';

		return ( statisticsStats);
	}

	// This comprehensive function is for precip, stage, and flow stations.
	// interval is only used for precip.
	createTooltipContent ( features, latitude, longitude, dataTypeArray, statisticType, duration, interval ) {
		// console.log('In createTooltipContent');
		const self = this;
		let tooltipContent = '';
		// precip has several more steps involved so isPrecip is a more readable/highly used boolean
		const isPrecip = dataTypeArray.includes('Precip') ? true : false;

		// sift through every feature to find all that match the latitude and longitude passed in the parameter list
		features.forEach(function(feature, index) {
			if ( feature.properties.stationSummary.latitude === latitude && feature.properties.stationSummary.longitude === longitude ) {
				// first the name and id regardless of the status
				tooltipContent += 
					'<span class=\'tooltipHeader\'>' + 
					feature.properties.stationSummary.name + 
					'</span><br>' + 'id: ' + 
					feature.properties.stationSummary.numId + '<br>';

				// 3 possible status outcomes:
				// 		1) out of service
				// 		2) last statistical value(s)
				// 		3) in service but no report
				if ( feature.properties.stationSummary.outOfService === true )	{
					tooltipContent += 'Out of service<br><br>';
				} else {
					// tmpStatistics are the statistics for all durations
					// tmpStatistic is the statistic for the specified duration
					const tmpStatistics = feature.properties.stationSummary.statistics.filter(function(stat) {
						return dataTypeArray.includes(stat.dataType);
					});
					const tmpStatistic = tmpStatistics.filter(function(stat) {
						return stat.duration.toUpperCase() === duration.toUpperCase() &&
							stat.statisticType === statisticType;
					});

					const statisticTypes:any[] = [];
					let lastReportStat:any = null;
					let columns;
					if ( isPrecip ) {
						statisticTypes.push ( 'Total');
						columns = self.tooltipTablePORPrecip;
						const sss = feature.properties.stationSummary.statistics.filter(function(stat) {
						return (stat.dataType === 'PrecipAccum');
							});
						// Precip Total is calculated rather than instantaneous
						// Use PrecipAccum's last report date/time
						lastReportStat = self.getLastReportStatistic (
							sss, 'Last' );
					} else {
						statisticTypes.push ( 'Last', 'Max', 'Min');
						columns = self.tooltipTablePOROther;
						lastReportStat = self.getLastReportStatistic (
							tmpStatistics, statisticTypes[0] );
					}

					// add last report date
					if ( lastReportStat != null ) {
						tooltipContent += 'Time of last report: ' + 
							self.dateToISOButLocal(
							lastReportStat.statisticDateTime) + '<br>';
					}
					
					let statisticsSummary = self.createTooltipTable ( 
						tmpStatistics, statisticTypes, columns );

					// If a stastistic was returned for the current datatype, stastistic type, and duration
					if ( tmpStatistic.length > 0 && tmpStatistic[0].statisticValue != null) {
						// console.log(tmpStatistic[0].novaScore);
						const novaScore = self.convertNovaScore( 
							self.novaScores, tmpStatistic[0].novaScore );
						const alarmsMessage = self.createAlarmMessage ( 
							feature.properties.stationSummary['alarms'],
							self.alarmTriggers );

					// add report created date
					const computeDateString = lastReportStat != null ? 
						'Current time used to compute statistics: ' + 
							self.dateToISOButLocal( lastReportStat.periodEnd) + '<br>' : '';

						tooltipContent +=
							'<span class=\'tooltipContent\'>' +
							statisticsSummary +
							computeDateString +
							'Conditions: ' + self.convertGroupNovaScoreToDescription(
								self.novaScores, novaScore) +
							alarmsMessage +
							'<br>Click marker for more information</span><br>';
					} else { // no report but still in service
						// precipitation no report
						// If station truly has no reports, then tooltipContent should just say "No report".
						// But if there are any reports, display all reports.
						if ( isPrecip ) {
							let statisticsSummaryStringNR = '';
							if ( statisticsSummary.length !== 0 ) {
								statisticsSummaryStringNR = ' in ' + interval + statisticsSummary;
							}
							tooltipContent += 'No report' + statisticsSummaryStringNR;
						// all other data types no report
						} else {
							tooltipContent += 'No report<br><br>';
						}
					}
				}
			}
		});
		return tooltipContent;
	}

	getActiveLayers():Promise<any[]> {
		const self = this;

		return new Promise(function(resolve, reject) {
			const layers:any[] = [];
			for ( let i = 0; i < dataLayerDetails.length; i++) {
				if ( dataLayerDetails[i].active == true ) {
					layers.push(dataLayerDetails[i]);
				}
			}

			resolve( layers );
		});
	}	

	setDataLayerDetailsOnFeature (item, dl) {
		// console.log(dl);
		item['dataType'] = dl.dataType;
		item['novaScoreString'] = dl.novaScore;
		item['titleString'] = dl.title;
		item['shapeString'] = dl.shape;
	}

	// Given the definition of a data layer, parse out the data
	parseAdditionalDataLayers() {
		// console.log(this.currentAddnlDataLayer);
		const uri = this.configService.createURI ( 
			{ 
				'filename': this.currentAddnlDataLayer.url
				//  ,
				// ...this.currentAddnlDataLayer
			}
		);
			/*
			{"id": "batteryVoltage", 
				"label": "Battery Voltage",
				"url": "stationSummaries.geojson",
				"dataType": "VoltageBattery",
				"statisticType": "Last",
				"duration": "1day",
				"title": "statistics.statisticValue"
			}
			*/

		const self = this;
		let unitsString = '';

		return new Promise(function(resolve, reject) {

			self.http.get(uri).subscribe (
				stationSummary => {

				if ( self.currentAddnlDataLayer.dataType != "name") {
				// console.log(stationSummary);
					// filter the features to only include those containing dataTypes of the additional layer
					stationSummary['features'] = stationSummary['features'].filter(function(s) {
						const dt = s.properties.stationSummary.dataTypes;
						const dt_filtered = dt.filter(function (d) { return d.name === self.currentAddnlDataLayer.dataType; });
						return dt_filtered.length === 0 ? false : true; });
				}

				// now prepare each station to include a title for map display
				// add "bonusTitle" to the json object
				// If station is out of service, set bonusTitle to "OOS" and novaScore to -1
				// If station has no report, set bonusTitle to "NR" and novaScore to 0

				// first set the novaScores array and alarm triggers
				const novaScores = self.parseAndSetNovaScores( stationSummary );
				const alarmTriggers = self.parseAndSetAlarmTriggers( stationSummary );

				const dataLayer = self.getDataLayerDetails( 'addnlData' );
				stationSummary['features'].forEach(function(item, index) {
					self.setDataLayerDetailsOnFeature (item, dataLayer);

					// create popupContent
					item.properties.stationSummary.popupContent = self.createPopupContent ( 
						stationSummary['features'], item.properties.stationSummary.latitude, item.properties.stationSummary.longitude );

					if ( self.currentAddnlDataLayer.dataType == "name") {
								item.properties.stationSummary.bonusTitle = item.properties.stationSummary.name;
								item.properties.stationSummary.bonusNovaScore = 1;

					} else {

					// create tooltipContent
					item.properties.stationSummary.tooltipContent = self.createTooltipContent ( 
						stationSummary['features'], item.properties.stationSummary.latitude, item.properties.stationSummary.longitude,
						[self.currentAddnlDataLayer.dataType], 
						self.currentAddnlDataLayer.statisticType, 
						self.currentAddnlDataLayer.duration, null );

					if ( item.properties.stationSummary.outOfService === true ) {
							item.properties.stationSummary.bonusTitle = 'OOS';
							item.properties.stationSummary.bonusNovaScore = -1;
					} else {
						const tmpStatistic = item.properties.stationSummary.statistics.filter(function(stat) {
							return stat.dataType === self.currentAddnlDataLayer.dataType && 
							stat.statisticType === self.currentAddnlDataLayer.statisticType && 
							stat.duration.toUpperCase() === self.currentAddnlDataLayer.duration.toUpperCase();
						});
						if ( tmpStatistic.length > 0 && tmpStatistic[0].statisticValue != null) {
								if ( unitsString === '' ) {
									unitsString = tmpStatistic[0].statisticUnits;
								}
								// console.log(tmpStatistic[0].novaScore);
								const novaScore = self.convertNovaScore( self.novaScores, tmpStatistic[0].novaScore );

								// If desired title is part of the station info, set it now.
								let precision = 0;
								if ( self.currentAddnlDataLayer.title.startsWith('statistics')) {
									const parts = self.currentAddnlDataLayer.title.split('.');
									if ( parts.length === 3 ) {
										// Something like statistics.statisticValue.0 meaning stationSummary.statistics.statisticValue rounded to 0 decimals
										precision = +parts[2];
									}
								}

								item.properties.stationSummary.bonusTitle = tmpStatistic[0].statisticValue.toFixed(precision);
								item.properties.stationSummary.bonusNovaScore = novaScore;
							} else { // no report but still in service
								item.properties.stationSummary.bonusTitle = 'NR';
								item.properties.stationSummary.bonusNovaScore = 0;
							}
					}
					}
				});
				// console.log(stationSummary);

				dataLayer.value = stationSummary;
				dataLayer.valueObservable.next( stationSummary );
				dataLayer.units = unitsString;
				dataLayer.novaScoreDescriptions = novaScores;
				console.log ( '[' + new Date().toLocaleTimeString() + '] Parsing all ' + 
					self.currentAddnlDataLayer.dataType + 
					' stations was successfully completed.');
				// console.log ( dataLayer );

				resolve(stationSummary['features'].length);
			});	
		})
	}

	// Parses the stationSummaries.geojson file which is an input to the function, filters the features so only those containing dataType
	// of "DischargeRiver" are included and stores the results in the "streamflowStations" layer.
	// Information is added to this layer so station has a title and a NovaScore at the main level.
	// This is used in the map display.
	// A count is also made of the number of stations with no report, out of service, and each of the
	// NovaScore values (1-5).
	parseDataLayersDischargeRiver (allStations) {
		const self = this;
		let unitsString = '';
		// first copy all the station data so data is not removed from the allStations object
		const tmpFlowStations = JSON.parse(JSON.stringify(allStations));

		return new Promise(function(resolve, reject) {

			// filter the features to only include those containing dataTypes of "DischargeRiver"
			tmpFlowStations.features = tmpFlowStations.features.filter(function(s) {
				const dt = s.properties.stationSummary.dataTypes;
				const dt_filtered = dt.filter(function (d) { return d.name === 'DischargeRiver'; });
				return dt_filtered.length === 0 ? false : true; });
			// now prepare each station to include a title for map display
			// add "dischargeRiverTitle" to the json object
			// If station is out of service, set dischargeRiverTitle to "OOS" and novaScore to -1
			// If station has no report, set dischargeRiverTitle to "NR" and novaScore to 0
			self.flowNRCount = 0;
			self.flowNSCount = 0;
			self.flowNS1Count = 0;
			self.flowNS2Count = 0;
			self.flowNS3Count = 0;
						self.flowNS4Count = 0;
			self.flowNS5Count = 0;

			// first set the novaScores array and alarm triggers
			const novaScores = self.parseAndSetNovaScores( tmpFlowStations );
			const alarmTriggers = self.parseAndSetAlarmTriggers( tmpFlowStations );

			const dataLayer = self.getDataLayerDetails( 'streamFlowStations' );
			tmpFlowStations.features.forEach(function(item, index) {
				self.setDataLayerDetailsOnFeature (item, dataLayer);

				// create popupContent
				item.properties.stationSummary.popupContent = self.createPopupContent ( 
					tmpFlowStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude );
				// create tooltipContent
				item.properties.stationSummary.tooltipContent = self.createTooltipContent ( 
					tmpFlowStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude,
					['DischargeRiver'], 'Last', '1day', null );

				if ( item.properties.stationSummary.outOfService === true ) {
						item.properties.stationSummary.dischargeRiverTitle = 'OOS';
						item.properties.stationSummary.dischargeRiverNovaScore = -1;
						self.flowNSCount++;
						// console.log("Setting waterLevelRiverNovaScore to -1");
				} else {
					const tmpStatistic = item.properties.stationSummary.statistics.filter(function(stat) {
						return stat.dataType === 'DischargeRiver' && stat.statisticType === 'Last' && stat.duration.toUpperCase() === '1day'.toUpperCase();
					});
					if ( tmpStatistic.length > 0 && tmpStatistic[0].statisticValue != null) {
							if ( unitsString === '' ) {
								unitsString = tmpStatistic[0].statisticUnits;
							}
							// console.log(tmpStatistic[0].novaScore);
							const novaScore = self.convertNovaScore( self.novaScores, tmpStatistic[0].novaScore );
							switch ( novaScore ) {
								case 1: self.flowNS1Count++; break;
								case 2: self.flowNS2Count++; break;
								case 3: self.flowNS3Count++; break;
								case 4: self.flowNS4Count++; break;
								case 5: self.flowNS5Count++; break;
							}

							item.properties.stationSummary.dischargeRiverTitle = tmpStatistic[0].statisticValue.toFixed();
							item.properties.stationSummary.dischargeRiverNovaScore = novaScore;
						} else { // no report but still in service
							self.flowNRCount++;
							item.properties.stationSummary.dischargeRiverTitle = 'NR';
							item.properties.stationSummary.dischargeRiverNovaScore = 0;
						}
				}
			});
			// console.log(tmpFlowStations);

			dataLayer.value = tmpFlowStations;
			dataLayer.valueObservable.next( tmpFlowStations );
			dataLayer.units = unitsString;
			dataLayer.novaScoreDescriptions = novaScores;
			console.log ( '[' + new Date().toLocaleTimeString() + '] Parsing all stream flow stations was successfully completed.');
			// console.log ( dataLayer );

			resolve(self.flowNS1Count);
		});
	}

	// Parses the stationSummaries.geojson file which is an input to the function, filters the features so only those containing dataType
	// of "WaterLevelRiver" are included and stores the results in the "waterLevelStations" layer.
	// Information is added to this layer so station has a title and a NovaScore at the main level.
	// This is used in the map display.
	// A count is also made of the number of stations with no report, out of service, and each of the
	// NovaScore values (1-5).
	parseDataLayersWaterLevelRiver (allStations) {
		const self = this;
		let unitsString = '';
		// first copy all the station data so data is not removed from the allStations object
		const tmpStageStations = JSON.parse(JSON.stringify(allStations));

		return new Promise(function(resolve, reject) {

			// filter the features to only include those containing dataTypes of "WaterLevelRiver"
			tmpStageStations.features = tmpStageStations.features.filter(function(s) {
				const dt = s.properties.stationSummary.dataTypes;
				const dt_filtered = dt.filter(function (d) { return d.name === 'WaterLevelRiver' || d.name === 'WaterLevelLake' || d.name === 'WaterLevelPool'; });
				return dt_filtered.length === 0 ? false : true; });
			// Now prepare each station to include a title for map display
			// Add "waterLevelRiverTitle" to the json object
			// If station is out of service, set waterLevelRiverTitle to "OOS" and novaScore to -1
			// If station has no report, set waterLevelRiverTitle to "NR" and novaScore to 0
			self.stageNRCount = 0;
			self.stageNSCount = 0;
			self.stageNS1Count = 0;
			self.stageNS2Count = 0;
			self.stageNS3Count = 0;
			self.stageNS4Count = 0;
			self.stageNS5Count = 0;

			// first set the novaScores array and alarm triggers
			const novaScores = self.parseAndSetNovaScores( tmpStageStations );
			const alarmTriggers = self.parseAndSetAlarmTriggers( tmpStageStations );

			const dataLayer = self.getDataLayerDetails( 'waterLevelStations' );
			tmpStageStations.features.forEach(function(item, index) {
				self.setDataLayerDetailsOnFeature (item, dataLayer);

				item.properties.stationSummary.popupContent = self.createPopupContent ( tmpStageStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude );
				// create tooltipContent
				item.properties.stationSummary.tooltipContent = self.createTooltipContent ( 
					tmpStageStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude,
					['WaterLevelRiver', 'WaterLevelLake', 'WaterLevelPool'], 'Last', '1day', null );

				if ( item.properties.stationSummary.outOfService === true ) {
					item.properties.stationSummary.waterLevelRiverTitle = 'OOS';
					item.properties.stationSummary.waterLevelRiverNovaScore = -1;
					self.stageNSCount++;
					// console.log("Setting waterLevelRiverNovaScore to -1");
				} else {
					const tmpStatistic = item.properties.stationSummary.statistics.filter(function(stat) {
						return ( stat.dataType === 'WaterLevelRiver' || stat.dataType === 'WaterLevelLake' || stat.dataType === 'WaterLevelPool' ) && stat.statisticType === 'Last' &&
							stat.duration.toUpperCase() === '1day'.toUpperCase();
					});
					// console.log(item.properties.station.id);
					// console.log(tmpStatistic);
					if ( tmpStatistic.length > 0 && tmpStatistic[0].statisticValue != null) {
						if ( unitsString === '' ) {
								unitsString = tmpStatistic[0].statisticUnits;
						}
						// console.log(tmpStatistic);
						// console.log(tmpStatistic[0].statisticValue);
						const novaScore = self.convertNovaScore( self.novaScores, tmpStatistic[0].novaScore );
						switch ( novaScore ) {
							case 1: self.stageNS1Count++; break;
							case 2: self.stageNS2Count++; break;
							case 3: self.stageNS3Count++; break;
							case 4: self.stageNS4Count++; break;
							case 5: self.stageNS5Count++; break;
						}
						item.properties.stationSummary.waterLevelRiverTitle = tmpStatistic[0].statisticValue.toFixed(1);
						item.properties.stationSummary.waterLevelRiverNovaScore = novaScore;
					} else { // no report but still in service
						self.stageNRCount++;
						item.properties.stationSummary.waterLevelRiverTitle = 'NR';
						item.properties.stationSummary.waterLevelRiverNovaScore = 0;
					}
				}

			});
			// console.log(tmpStageStations);

			dataLayer.value = tmpStageStations;

			/*
			for ( let i = 0; i<tmpStageStations.features.length; i++) {
				console.log(tmpStageStations.features[i].properties.stationSummary.name);
			}
			*/

			dataLayer.valueObservable.next( tmpStageStations );
			dataLayer.units = unitsString;
			dataLayer.novaScoreDescriptions = novaScores;
			console.log ( '[' + new Date().toLocaleTimeString() + '] Parsing all water level stations was successfully completed.');
			// console.log ( dataLayer );

			resolve(self.stageNS1Count);
		});
	}

	// Parses the stationSummaries.geojson file which is an input to the function, filters the features so only those containing dataType
	// of "Precip" are included and stores the results in the "precipStations" layer.
	// Information is added to this layer so station has a title and a NovaScore at the main level.
	// This is used in the map display.
	// A count is also made of the number of stations with no report, out of service, and each of the
	// NovaScore values (1-5).
	parseDataLayersPrecip (allStations, interval) {
		const self = this;
		let unitsString = '';
		// first copy all the station data so data is not removed from the allStations object
		const tmpPrecipStations = JSON.parse(JSON.stringify(allStations));

		return new Promise(function(resolve, reject) {
			// filter the features to only include those containing dataTypes of "Precip"
			tmpPrecipStations.features = tmpPrecipStations.features.filter(function(s) {
				const dt = s.properties.stationSummary.dataTypes;
				const dt_filtered = dt.filter(function (d) { return d.name === 'Precip'; });
				return dt_filtered.length === 0 ? false : true; });
			// now prepare each station to include a title for map display
			// add "precipTitle" to the json object
			// If station is out of service, set precipTitle to "OOS" and novaScore to -1
			// If station has no report, set precipTitle to "NR" and novaScore to 0
			self.precipNRCount = 0;
			self.precipNSCount = 0;
			self.precipNS1Count = 0;
			self.precipNS2Count = 0;
			self.precipNS3Count = 0;
			self.precipNS4Count = 0;
			self.precipNS5Count = 0;

			// first set the novaScores array and alarm triggers
			const novaScores = self.parseAndSetNovaScores( tmpPrecipStations );
			// console.log(novaScores);
			const alarmTriggers = self.parseAndSetAlarmTriggers( tmpPrecipStations );

			let duration;
			switch ( interval ) {
				case '30-Minute Rainfall': duration = '30minute'; break;
				case '1-Hour Rainfall': duration = '1hour'; break;
				case '3-Hour Rainfall': duration = '3hour'; break;
				case '6-Hour Rainfall': duration = '6hour'; break;
				case '12-Hour Rainfall': duration = '12hour'; break;
				case '24-Hour Rainfall': duration = '1day'; break;
				case '3-Day Rainfall': duration = '3day'; break;
				case '7-Day Rainfall': duration = '7day'; break;
				case '14-Day Rainfall': duration = '14day'; break;
				case '21-Day Rainfall': duration = '21day'; break;
				case '30-Day Rainfall': duration = '30day'; break;
				case '15-Minute Rainfall':
				default: duration = '15minute'; break;
			}

			const dataLayer = self.getDataLayerDetails( 'precipStations' );
			tmpPrecipStations.features.forEach(function(item, index) {
				self.setDataLayerDetailsOnFeature (item, dataLayer);

				item.properties.stationSummary.popupContent = self.createPopupContent ( tmpPrecipStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude );
				item.properties.stationSummary.tooltipContent = self.createTooltipContent ( 
					tmpPrecipStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude,
					['Precip'], 'Total', duration, interval );

				if ( item.properties.stationSummary.outOfService === true ) {
					item.properties.stationSummary.precipTitle = 'OOS';
					item.properties.stationSummary.precipNovaScore = -1;
					self.precipNSCount++;
					// item.properties.stationSummary.tooltipContent = 'Out of service';
				} else {
					// tmpStatistic is the single statistic for the current duration
					const tmpStatistic = item.properties.stationSummary.statistics.filter(function(stat) {
						return stat.dataType === 'Precip' && stat.statisticType === 'Total' && stat.duration.toUpperCase() === duration.toUpperCase(); //  && stat.associatedPointNumId === item.properties.stationSummary.numId;
					});
					if ( tmpStatistic.length > 0 && tmpStatistic[0].statisticValue != null) {
						if ( unitsString === '' ) {
							unitsString = tmpStatistic[0].statisticUnits;
						}
						// console.log(tmpStatistic);
						// console.log(tmpStatistic[0].statisticValue);
						const novaScore = self.convertNovaScore( self.novaScores, tmpStatistic[0].novaScore );
						switch ( novaScore ) {
							case 1: self.precipNS1Count++; break;
							case 2: self.precipNS2Count++; break;
							case 3: self.precipNS3Count++; break;
							case 4: self.precipNS4Count++; break;
							case 5: self.precipNS5Count++; break;
						}
						item.properties.stationSummary.precipTitle = tmpStatistic[0].statisticValue.toFixed(2);
						// This is special for precip - set NovaScore to null for precip of 0;  this will set the marker color to white
						if ( tmpStatistic[0].statisticValue === 0 ) {
							item.properties.stationSummary.precipNovaScore = null;
						} else {
							item.properties.stationSummary.precipNovaScore = novaScore;
						}

					} else { // no report but still in service
						// console.log(item);
						self.precipNRCount++;
						item.properties.stationSummary.precipTitle = 'NR';
						item.properties.stationSummary.precipNovaScore = 0;
					}
				}
			});
			// console.log(tmpPrecipStations);

			// features ready to release to the data layer
			dataLayer.value = tmpPrecipStations;
			dataLayer.valueObservable.next( tmpPrecipStations );
			dataLayer.units = unitsString;
			dataLayer.novaScoreDescriptions = novaScores;
			console.log ( '[' + new Date().toLocaleTimeString() + '] Parsing all precip stations was completed successfully.');
			// console.log ( dataLayer );

			resolve(self.precipNS1Count);
		});
	}

	// Parses the floodImpactSummaries.geojson file.
	// Information is added to this layer so each asset has a title and a NovaScore at the main level.
	// This is used in the map display.
	// A count is also made of the number of stations with no report, out of service, and each of the
	// NovaScore values.
	parseDataLayersFloodImpact () {
		const self = this;
		let unitsString = '';

		return new Promise(function(resolve, reject) {
			const request = new XMLHttpRequest();
			request.onload = function ( ) {
				if ( request.readyState === request.DONE  ) {
					if ( request.status === 200 ) {

						// first, get fitAssetsGeoJSON file content
						const tmpFITStations = JSON.parse(request.responseText);

						// now prepare each asset to include a title for map display
						// add "fitTitle" to the json object
						self.fitNS14Count = 0;
						self.fitNS15Count = 0;
						self.fitNS16Count = 0;
						self.fitNS17Count = 0;
						self.fitNS18Count = 0;

						// first set the novaScores array and alarm triggers
						const novaScores = self.parseAndSetNovaScores( tmpFITStations );
						const alarmTriggers = self.parseAndSetAlarmTriggers( tmpFITStations );

						const dataLayer = self.getDataLayerDetails( 'fitAssetsGeoJSON' );
						tmpFITStations.features.forEach(function(item, index) {
							// item.properties.stationSummary.popupContent = self.createPopupContent ( tmpFITStations.features, item.properties.stationSummary.latitude, item.properties.stationSummary.longitude );
							self.setDataLayerDetailsOnFeature (item, dataLayer);

							const tmpStatistic = item.properties.floodImpactSummary.statistics.filter(function(stat) {
								return stat.dataType === 'DischargeRiver' && stat.statisticType === 'Last' && stat.duration.toUpperCase() === '1day'.toUpperCase();
							});
							if ( tmpStatistic.length > 0 && tmpStatistic[0].statisticValue != null) {
								if ( unitsString === '' ) {
										unitsString = tmpStatistic[0].statisticUnits;
								}
								// console.log(tmpStatistic);
								// console.log(tmpStatistic[0].statisticValue);
								// NOVASCORE statistics are currently hard-coded ... need to read from floodImpactSummaries.json
								const novaScore = self.convertNovaScore( self.novaScores, tmpStatistic[0].novaScore );
								switch ( novaScore ) {
									case 1: self.fitNS14Count++; break;
									case 2: self.fitNS15Count++; break;
									case 3: self.fitNS16Count++; break;
									case 4: self.fitNS17Count++; break;
									case 5: self.fitNS18Count++; break;
								}
								item.properties.floodImpactSummary.fitTitle = tmpStatistic[0].statisticValue;
								item.properties.floodImpactSummary.fitNovaScore = novaScore;
								item.properties.floodImpactSummary.tooltipContent =
											'<span class=\'tooltipHeader\'>' + item.properties.floodImpactSummary.name + '</span>' +
											'<br><span class=\'tooltipContent\'>' + tmpStatistic[0].statisticValue + ' ' + tmpStatistic[0].statisticUnits  +
											'<br>Capacity: ' + item.properties.floodImpactSummary.capacity + ' ' + item.properties.floodImpactSummary.capacityUnits +
											', 1-Day Last DischargeRiver prior to ' + 
											self.dateToISOButLocal(tmpStatistic[0].statisticDateTime) +
											'<br>Conditions: ' + self.convertGroupNovaScoreToDescription(self.novaScores, novaScore) +
											'<br>Click marker for more information</span>';
							} else { // no report but still in service
								item.properties.floodImpactSummary.fitTitle = 'NR';
								item.properties.floodImpactSummary.fitNovaScore = 0;
								item.properties.stationSummary.tooltipContent =
									'<span class=\'tooltipHeader\'>' + item.properties.stationSummary.name + '</span><br>' +
									'id: ' + item.properties.stationSummary.numId + '<br>' +
									'No report';
							}
						});
						// comment out or run into memory issues
						// console.log(tmpFITStations);

						dataLayer.value = tmpFITStations;
						dataLayer.valueObservable.next( tmpFITStations );
						dataLayer.units = unitsString;
						dataLayer.novaScoreDescriptions = novaScores;
						console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri +
							' for all flood impact assets was successfully completed.');
						// console.log ( dataLayer );

						resolve(self.fitNS14Count);
					} else {	// request status wasn't 200
						console.log ( '[' + new Date().toLocaleTimeString() + '] Reading ' + uri + ' for all flood impact assets was UNSUCCESSFUL.');
						// The following line puts the whole stack trace in red on the console.
						// reject(Error(request.statusText));
					}

				}
			};
			const uri = self.configService.createURI ( { 'filename': 'floodImpactSummaries.geojson' });
			request.open('get', uri, true );
			console.log('[' + new Date().toLocaleTimeString() + '] Attempting to read ' + uri + ' for all flood impact assets.');
			request.send();
		});
	}

	// refreshLegendList uses addToLegendListSource to add the appropriate content based on active data layers
	refreshLegendList() {
		const self = this;
		let activeDataDisplayLayerFound = false;
		const dataTypes = [ 'precipStations', 'waterLevelStations', 'streamFlowStations' ];

		// clear previous values
		for ( let i = 0; i < 6; i++ ) {
			this.addToLegendListSource ( i, 'dataDisplayLayer', '', '' );
			this.addToLegendListSource ( i, 'fit', '', '' );
		}

		for ( let i = 0; i < dataTypes.length; i++ ) {
			if ( activeDataDisplayLayerFound === false ) {  // only need to do once
				const dataLayer = this.getDataLayerDetails ( dataTypes[i] );
				if ( dataLayer.active ) {
					activeDataDisplayLayerFound = true;
					dataLayer.novaScoreDescriptions.forEach(function(item, index) {
						self.addToLegendListSource ( item.id, 'dataDisplayLayer', item.description, dataLayer.units );
					});
				}
			}
		}

		// now check for flood impact
		const dataLayer = this.getDataLayerDetails ( 'fitAssetsGeoJSON' );
		if ( dataLayer.active ) {
			dataLayer.novaScoreDescriptions.forEach(function(item, index) {
				self.addToLegendListSource ( item.groupScoreOrder, 'fit', 'FIT: ' + item.shortDisplayName, dataLayer.units );
			});
		}

	}
	// addToLegendListSource adds to an observable stream the content of the currently active data layers.
	// The content added to legendList$ is in the form of a group:
	// 		{ "id": novaScoreLevel, "description": novaScoreDescription }
	addToLegendListSource ( id, type, description, units ) {
		const novaScoreGroup = {};
		novaScoreGroup['id'] = id;
		novaScoreGroup['dataType'] = type;
		novaScoreGroup['units'] = units;
		novaScoreGroup['description'] = description;
		this.legendListSource.next( novaScoreGroup );
	}

	// call this routine to emit a value on filterEventSource
	// This indicates to data-layer-highlight to refilter the current stations displayed.
	// At this point, reason isn't being used but could be in the future. 
	triggerMapFilterEvent ( reason ) {
		this.filterEventSource.next( reason );
	}

	// Takes a date string from data web services and converts it to
	// a more readable string.  Taking advantage of the fact that Sweden's
	// format is very much like ISO.
	dateToISOButLocal(dateString) {
		const dateObj = new Date(dateString);
		return dateObj.toLocaleString('sv').replace(' ', 'T');
	}

	getPrecipCounts() {
		const counts = this.getBasicCounts(
			this.precipNRCount,
			this.precipNSCount,
			this.precipNS1Count,
			this.precipNS2Count,
			this.precipNS3Count,
			this.precipNS4Count,
			this.precipNS5Count
			);
		// console.log(counts);
		return counts;
	} 

	getFITCounts() {
		const counts = this.getBasicCounts(
			0,
			0,
			this.fitNS14Count,
			this.fitNS15Count,
			this.fitNS16Count,
			this.fitNS17Count,
			this.fitNS18Count
			);
		// console.log(counts);
		return counts;
	} 

	getStageCounts() {
		const counts = this.getBasicCounts(
			this.stageNRCount,
			this.stageNSCount,
			this.stageNS1Count,
			this.stageNS2Count,
			this.stageNS3Count,
			this.stageNS4Count,
			this.stageNS5Count
			);
		// console.log(counts);
		return counts;
	} 

	getFlowCounts() {
		const counts = this.getBasicCounts(
			this.flowNRCount,
			this.flowNSCount,
			this.flowNS1Count,
			this.flowNS2Count,
			this.flowNS3Count,
			this.flowNS4Count,
			this.flowNS5Count
			);
		// console.log(counts);
		return counts;
	} 

	getBasicCounts(noReportCount, noServiceCount, novascore1Count, novascore2Count, novascore3Count, novascore4Count, novascore5Count ) {
		const xdiff = 27;
		const xtextDiff = 2;
		let index = 0;
		// currently, rect.stroke not being used - looks cleaner without
		return [
			{
				rect: {x: "" + (xdiff*index), stroke: "black", fill: "black"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "white", count: noReportCount}
			},
			{
				rect: {x: "" + (xdiff*index), stroke: "#106AB6", fill: "#106AB6"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "black", count: noServiceCount}
			},
			{
				rect: {x: "" + (xdiff*index), stroke: "#008A36", fill: "#008A36"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "black", count: novascore1Count}
			},
			{
				rect: {x: "" + (xdiff*index), stroke: "black", fill: "#F5B831"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "black", count: novascore2Count}
			},
			{
				rect: {x: "" + (xdiff*index), stroke: "#EE8818", fill: "#EE8818"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "black", count: novascore3Count}
			},
			{
				rect: {x: "" + (xdiff*index), stroke: "#B63D91", fill: "#B63D91"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "black", count: novascore4Count}
			},
			{
				rect: {x: "" + (xdiff*index), stroke: "#D12619", fill: "#D12619"},
				text: {x: "" + (xdiff*index++ + xtextDiff), stroke: "black", count: novascore5Count}
			}
		]
	}

	private handleError (error: any): Observable<string> {
		console.log(error);
		const errMsg = (error.message) ? error.message :
			error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		console.error(errMsg); // log to console instead
		return observableThrowError(errMsg);
	}
}
